import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import DocumentPortalInPerson from 'components/byesign/documentPortalInPerson';

export default connect(store => {
  return {
    showPage: store.authentication.showPage,
    documentToSign: store.landlordApplications.documentToSign,
  };
})(
  class LeaseInPersonOverwriteCreator extends Component {
    componentDidMount = () => {
      if (!this.props.documentToSign) {
        browserHistory.push('/companies');
        return;
      }
    };

    goToApplicationsPage = () => {
      if (this.props.documentToSign.document_type === 'LEASE_RENEWAL') {
        browserHistory.push('/companies/rent_roll');
        return;
      }

      browserHistory.push('/companies/applications');
    };

    render() {
      return (
        <div className="body" role="main">
          {this.props.showPage &&
            this.props.documentToSign && (
              <DocumentPortalInPerson
                {...this.props.documentToSign}
                onContinue={this.goToApplicationsPage}
                isModeInternal={true}
              />
            )}
        </div>
      );
    }
  }
);
